export default __webpack_public_path__ + "c0bb959b874c947cac24ef6b30c69a0e.svg";